import React from 'react'
import '../style.css'

function Cover() {
    return (
        <div className = "cover-container">
            <h1>Coming Soon!</h1>
        </div>
    )
}

export default Cover;